import * as S from './SeenOnSection.styles'
import { useMemo } from 'react'

import { ReactComponent as nbcLogo } from 'images/homePage/seenOn/nbc.svg'
import { ReactComponent as abcLogo } from 'images/homePage/seenOn/abc.svg'
import { ReactComponent as nypostLogo } from 'images/homePage/seenOn/nypost.svg'
import { ReactComponent as oprahLogo } from 'images/homePage/seenOn/oprah.svg'
import { ReactComponent as todayLogo } from 'images/homePage/seenOn/today.svg'
import { ReactComponent as cLogo } from 'images/homePage/seenOn/c.svg'
import useScreenSize from '../../../../hooks/useScreenSize'
import { useTranslation } from 'react-i18next'

const logos = [todayLogo, abcLogo, oprahLogo, nbcLogo, nypostLogo, cLogo]
const MAX_NUM_LOGOS_MOBILE = 5

export default function SeenOnSection() {
  const { t } = useTranslation()
  const isMediumScreen = useScreenSize('md')
  const filteredLogos = useMemo(
    () => (!isMediumScreen ? logos.slice(0, MAX_NUM_LOGOS_MOBILE) : logos),
    [isMediumScreen]
  )

  return (
    <>
      <S.Container>
        <S.TitleContainer>
          <S.FlexSeparator />
          {isMediumScreen
            ? t('homepage.seen-on-desktop')
            : t('homepage.seen-on')}
          <S.FlexSeparator />
        </S.TitleContainer>
        <S.LogosContainer>
          {filteredLogos.map((Logo, i) => (
            <S.LogoItem key={i}>
              <Logo />
            </S.LogoItem>
          ))}
        </S.LogosContainer>
      </S.Container>
      {!isMediumScreen && <S.WideSeparator />}
    </>
  )
}
